export function checkhysteresis(x, y, px, py) {
  //console.log("checkhysteresis:",x," ",y," ",px," ",py);

  if (px == null || py == null) return false;

  if (x >= px - 8 && x <= px + 8) {
    if (y >= py - 8 && y <= py + 8) {
      //console.log("Inbounds");
      return true;
    }
  }

  return false;
}
